import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { HeartIcon, ShieldCheckIcon, HandshakeIcon, PillIcon, HomeIcon, UserIcon, UsersIcon, MoveIcon, ConciergeBellIcon, SparklesIcon, BrushIcon, CarIcon, CheckCircleIcon } from 'lucide-react';
const servicesList = [{
  name: 'Respite Care',
  icon: HeartIcon
}, {
  name: 'Companionship Services',
  icon: HandshakeIcon
}, {
  name: 'Medication Management',
  icon: PillIcon
}, {
  name: 'Homemaking',
  icon: HomeIcon
}, {
  name: 'Personal Care',
  icon: UserIcon
}, {
  name: 'Live In / Live Out',
  icon: UsersIcon
}, {
  name: 'Mobility Assistance',
  icon: MoveIcon
}, {
  name: 'Concierge Services',
  icon: ConciergeBellIcon
}, {
  name: 'Hygiene Assistance',
  icon: SparklesIcon
}, {
  name: 'Light Housekeeping',
  icon: BrushIcon
}, {
  name: 'Transportation & Errands',
  icon: CarIcon
}];
export function AboutSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="about" className="py-12 md:py-16 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-20">
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-22">
              About Edvin Home Healthcare
            </h2>
            <div className="w-20 h-1.5 bg-secondary mx-auto mb-6 rounded-full" data-id="element-23"></div>
          </div>

          {/* Hero Image */}
          <div className="mb-16 rounded-2xl overflow-hidden shadow-card-hover" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/2kGX94xbQuji2osUz8iKU6/1.jpg" alt="Caregiver with elderly couple at home" className="w-full h-64 md:h-80 object-cover" data-id="element-25" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-26">
            {/* Content Side */}
            <div data-id="element-27">
              <div className="space-y-6 text-lg text-dark-muted" data-id="element-28">
                <p data-id="element-29">
                  Edvin Home Healthcare Solutions provides a wide array of home
                  health personnel services to meet the needs of both the client
                  and family. All services are monitored by a Registered Nurse
                  and designed to assure safe, reliable, and affordable care in
                  the home or residential living facility.
                </p>
                <p data-id="element-30">
                  We utilize pre-employment screening measures to ensure clients
                  are matched with an experienced and compassionate home health
                  aide.
                </p>
              </div>

              {/* RN Monitored Badge */}
              <div className="mt-8 flex items-center bg-primary/5 border border-primary/20 rounded-xl p-5" data-id="element-31">
                <ShieldCheckIcon className="h-10 w-10 text-primary mr-4 flex-shrink-0" data-id="element-32" />
                <div data-id="element-33">
                  <h4 className="font-bold text-dark" data-id="element-34">RN Monitored Care</h4>
                  <p className="text-sm text-dark-muted" data-id="element-35">
                    All services are supervised by a Registered Nurse for your
                    safety and peace of mind.
                  </p>
                </div>
              </div>
            </div>

            {/* Services List Side */}
            <div className="bg-light-alt rounded-2xl p-8 border border-gray-100 shadow-card" data-id="element-36">
              <h3 className="text-xl font-bold text-dark mb-6" data-id="element-37">
                We offer the following services:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-38">
                {servicesList.map((service, idx) => <div key={idx} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-white hover:shadow-sm transition-all group" data-id="element-39">
                    <div className="bg-primary/10 p-2 rounded-lg group-hover:bg-primary transition-colors duration-300 flex-shrink-0" data-id="element-40">
                      <service.icon className="h-5 w-5 text-primary group-hover:text-white transition-colors duration-300" data-id="element-41" />
                    </div>
                    <span className="font-medium text-dark-muted group-hover:text-dark transition-colors" data-id="element-42">
                      {service.name}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}